import React, { useRef } from 'react';
import { highlightText } from '@/pages/aigc/pages/Agent/components/Tabs/utils/highlight';
import './ChatItem.scss';
import { IChatItemProps } from './_type';
import CommonBubble from '@home/components/CommonBubble';
import { useBubblePlacement } from './hooks/useBubblePlacement';

const ChatItem: React.FC<IChatItemProps> = ({
  title,
  id,
  active,
  searchQuery,
  onMouseEnter,
  onClick,
}) => {
  const titleRef = useRef<HTMLSpanElement>(null);
  
  // 使用自定义 Hook 管理气泡位置
  const { bubbleInfo, showBubble, hideBubble } = useBubblePlacement(titleRef, {
    bubbleWidth: 314,
    margin: 20
  });

  const handleClick = () => {
    onClick?.(id);
  };

  const handleMouseEnter = () => {
    onMouseEnter?.(id);
    
    // 检查文本是否超出容器宽度
    if (titleRef.current && titleRef.current.scrollWidth > titleRef.current.clientWidth) {
      const targetElement = titleRef.current.parentElement?.parentElement as HTMLDivElement;
      showBubble(title || '', targetElement);
    }
  };

  const handleMouseLeave = () => {
    onMouseEnter?.('');
    hideBubble();
  };

  // 获取显示的文本内容
  const displayText = searchQuery?.searchKeyword
    ? highlightText(title || '', searchQuery.searchKeyword)
    : title;

  return (
    <>
      <div
        className={`dba-copilot-history-chat-item ${active ? 'dba-copilot-history-chat-item--active' : ''}`}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="dba-copilot-history-chat-item__content">
          {/* 标题内容 */}
          <div className="dba-copilot-history-chat-item__title">
            <span 
              ref={titleRef}
              className="dba-copilot-history-chat-item__title-text"
            >
              {displayText}
            </span>
          </div>
        </div>
      </div>
      {/* 气泡提示 - 只有当文本超出时才显示 */}
      {bubbleInfo && (
        <CommonBubble 
          visible={true} 
          dark 
          placement={bubbleInfo.placement} 
          referenceElement={bubbleInfo.ele} 
          content={bubbleInfo.text}
          overlayClassName="dba-nav-menu-overlay"
        />
      )}
    </>
  );
};

export default ChatItem;